<template>
    <div class="md-house-facts fashion" :style="{ marginBottom, paddingTop }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            noPadding
            noMargin
            v-if="exist"
        >
            <div class="title">
                <h2 class="mg-title">{{ cmpTitle }}</h2>
                <div class="tip">{{ cmpTip }}</div>
            </div>
            <div class="content-box">
                <div
                    class="content"
                    v-for="(item, index) in facts"
                    :key="index"
                >
                    <div class="fact-box">
                        <div
                            class="icon iconfont"
                            :class="item.iconClass"
                        ></div>
                        <div class="express-content">
                            <p class="number" :class="item.numberClass">
                                <i
                                    class="iconfont"
                                    :class="item.trend"
                                    v-if="item.trend"
                                ></i
                                ><span>{{ item.number }}</span
                                ><span v-if="item.trend" class="percent"
                                >%</span
                                >
                            </p>
                            <p class="expressText">{{ item.expressText }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <div class="tip">{{ cmpTip }}</div>
                <button class="bt-contact" @click="handleContact">
                    {{ cmpContactBTText }}
                </button>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';

.md-house-facts.fashion {
    padding: 20px 0px;
    .mg-container {
        overflow: visible;
    }
    .title {
        position: relative;
        padding-bottom: 20px;
        // mobile
        .tip {
            display: none;
            margin-top: 5px;
            font-size: 12px;
            color: #8b93a7;
            text-align: var(--mg-title-align);
        }
    }
    .content-box {
        height: 180px;
        margin: 0 0 30px 0;
        display: inline-block;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
        .content {
            display: inline-block;
            box-shadow: 0 0 5px rgba(0, 10, 30, 0.1);
            margin: 0 10px;
            width: 320px;
            height: 100%;
            border-radius: 4px;
            &:nth-child(1) {
                margin-left: 0;
            }
            &:last-child {
                margin-right: 0;
            }
            .fact-box {
                height: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;
                --height: 60px;
                .icon {
                    flex: 1;
                    text-align: center;
                    flex-basis: var(--height);
                    font-size: 32px;
                    line-height: var(--height);
                    &::before {
                        border-radius: var(--height);
                        display: inline-block;
                        height: var(--height);
                        width: var(--height);
                    }
                }
                .icon-v3-Increase.icon::before {
                    color: #1774f1;
                }

                .green {
                    color: #29cb90;
                }
                .red {
                    color: #ff3b3b;
                }
                p.number {
                    font-size: 36px;
                    height: 30px;
                    line-height: 30px;
                    margin-bottom: 20px;
                    font-family: var(--font-bold);
                    span.percent {
                        font-size: 18px;
                    }
                    .iconfont {
                        margin-right: 5px;
                    }
                }
                .express-content {
                    flex: 5;
                    height: 80px;
                    .expressText {
                        height: 30px;
                        line-height: 18px;
                    }
                }
            }
        }
    }
    .footer {
        width: 100%;
        text-align: center;
        .tip {
            color: #8b93a7;
            font-size: 14px;
            text-align: var(--mg-title-align);
        }
        .bt-contact {
            margin-top: 12px;
            text-align: center;
            text-transform: uppercase;
            cursor: pointer;
            font-family: var(--font-bold);
            font-size: 16px;
            border-radius: 2px;
            padding: 10px 30px;
            min-width: 343px;
            @include color-button();
        }
    }
    @include media-600 {
        .mg-container {
            overflow: visible;
        }
        .content-box {
            height: unset;
            flex-direction: column;
            margin: 0;
            .content {
                height: 130px;
                margin: 0 0 15px 0;
                max-width: unset;
                width: 100%;
                .number {
                    font-size: 28px;
                }
                .express-text {
                    font-size: 14px;
                }
            }
        }
        .footer {
            padding: 0 22px;
            .tip {
                display: none;
            }
            .bt-contact {
                font-family: var(--font-bold);
                font-size: 16px;
                border-radius: 2px;
                color: var(--color-theme);
                background-color: #ffffff;
                padding: 10px;
                width: 100%;
                min-width: auto;
                border: solid 2px var(--color-theme);
            }
        }
        .title {
            .tip {
                display: block;
            }
        }
    }
}
</style>
